import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "./HomeCollections.css";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

const HomeCollections = () => {
  const [collections, setCollections] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const visibleCards = window.innerWidth <= 768 ? 2 : 3;

  const nextSlide = () => {
    if (currentIndex < collections.length - visibleCards) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/products`);

      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }

      const products = await response.json();
    const uniqueCollections = [
      ...new Set(
        products
          .map((product) => product.brand)
          .filter(Boolean)
      ),
    ];

    // Latest collection first — update this list as you launch collections
    const collectionOrder = [
      "STILL Amara",
      "STILL Present",
      "STILL Sundrenched",
      "STILL Defined",
      "STILL Rising",
      "STILL Composed",
      "STILL Standing",
      "STILL Commanding",
    ];

    const sortedCollections = uniqueCollections.sort((a, b) => {
      const indexA = collectionOrder.indexOf(a);
      const indexB = collectionOrder.indexOf(b);

      // Collections not listed above appear after the known collections
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    setCollections(sortedCollections);
    } catch (error) {
      console.error("Error loading collections:", error);
    }
  };


  return (
    <section className="homeCollections">
      <div className="homeCollections-header">
        <span>THE COLLECTIONS</span>

        <h2>Curated for Every Pace</h2>

        <p>
          Explore signature collections designed with timeless silhouettes,
          modern structure, and effortless versatility.
        </p>
      </div>

      <div className="collectionSlider">
        <button
          className={`collectionArrow left ${
            currentIndex === 0 ? "hidden" : ""
          }`}
          onClick={prevSlide}
        >
          <FiChevronLeft />
        </button>

        <div className="collectionViewport">

          <div
            className="collectionTrack"
            style={{
              transform: `translateX(calc(-${currentIndex} * (100% / ${visibleCards})))`,
            }}
          >
            {collections.map((collection) => (
              <Link
                key={collection}
                to={`/collection/${encodeURIComponent(collection)}`}
                className="collectionCard"
              >
                <div className="collectionImage">
                  <img
                    src={`/collections/${collection.replace(/\s+/g, "")}.jpeg`}
                    alt={collection}
                  />
                </div>

                <div className="collectionInfo">
                  <h3>{collection}</h3>

                  <span>
                    Explore
                    <span className="arrow">→</span>
                  </span>
                </div>
              </Link>
            ))}
          </div>

        </div>

        <button
          className={`collectionArrow right ${
            currentIndex >= collections.length - visibleCards ? "hidden" : ""
          }`}
          onClick={nextSlide}
        >
          <FiChevronRight />
        </button>
      </div>
    </section>
  );
};

export default HomeCollections;
